
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/miners-upgrade",
      function () {
        return require("private-next-pages/miners-upgrade/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/miners-upgrade"])
      });
    }
  